import { requestFunnel } from '@/application/api';

export const getRegions = async country => {
  const result = await requestFunnel.get(`regions/${country}`);
  return result.data;
};
